// extracted by css-extract-rspack-plugin
export default {"authorLoginLink":"IssueBodyHeaderAuthor-module__authorLoginLink__aTls_","noProfileLink":"IssueBodyHeaderAuthor-module__noProfileLink__de7ic"};